import idleCallback from "common/utils/ui/idle_callback";

const HIDDEN_CLASSNAME = "hidden";

const selectCategory = ({
  navigationLinks$,
  navigationContentElements$,
  detailsContentElements$,
  activeLinkClassName,
  category
}) => {
  const activeCategory = category || navigationContentElements$[0]?.dataset?.category;

  navigationLinks$.forEach(navLink => {
    navLink.classList.toggle(activeLinkClassName, navLink.dataset.category === activeCategory);
  });

  navigationContentElements$.forEach(content => {
    content.classList.toggle(HIDDEN_CLASSNAME, content.dataset.category !== activeCategory);
  });

  idleCallback(() => {
    detailsContentElements$.forEach(content => {
      content.classList.toggle(HIDDEN_CLASSNAME, content.dataset.category !== category);
    });
  });
};

const createNavigationInitializer = ({
  navigationLinksSelector,
  navigationContentSelector,
  detailsContentSelector,
  activeLinkClassName
}) => {
  const $getNavigationLinks = () => document.querySelectorAll(navigationLinksSelector);
  const $getNavigationContent = () => document.querySelectorAll(navigationContentSelector);
  const $getDetailsContent = () => document.querySelectorAll(detailsContentSelector);

  let abortController = null;

  const initNavigation = () => {
    if (abortController) abortController.abort();
    abortController = new AbortController();
    const { signal } = abortController;

    $getNavigationLinks().forEach(link => {
      const listener = event => {
        const activeLink = event.target;
        const activeCategory = activeLink.dataset.category;
        selectCategory({
          navigationLinks$: $getNavigationLinks(),
          navigationContentElements$: $getNavigationContent(),
          detailsContentElements$: $getDetailsContent(),
          activeLinkClassName,
          category: activeCategory
        });
      };

      link.addEventListener("click", listener, { signal });
      link.addEventListener("mouseover", listener, { signal });
    });
  };

  return initNavigation;
};

export default createNavigationInitializer;
